import { atom } from "recoil";

import { SystemSettingsDto } from "../../models";

export const systemSettingsDtoAtom = atom<SystemSettingsDto | undefined>({
  key: "systemSettingsDtoAtom",
  default: undefined,
});
